
import { Home } from './Components/Home';
import './App.css';
import {Route,Routes} from 'react-router-dom'
import { About } from './Components/About';
import { Contact } from './Components/Contact';
import { Navbar } from './Components/Navbar';
import { Footer } from './Components/Footer';
import { ImagePage } from './Components/ImagePage'; 
import Gallery from './Components/Gallery';
import BasindaBiz from './Components/BasindaBiz';
import FlipBookViewer from './Components/FlipBookViewer';
import ContestPage from './Components/ContestPage';
import ConfirmationPage from './Components/ConfirmationPage';
import ApplicationPage from './Components/ApplicationsPage';
import UploadPage from './Components/UploadPage';
import ResultsPage from './Components/ResulsPage';
import EylemPlaniViewer from './Components/EylemPlaniViewer';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Routes>
        <Route path='/' exact element={<Home/>} />
        <Route path='/about' exact element={<About/>} />
        <Route path='/contact' exact element={<Contact/>} />
        <Route path="/image" element={<ImagePage />} />
        <Route path="/BasindaBiz" element={<BasindaBiz />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/FlipBookViewer" element={<FlipBookViewer />} />
        <Route path="/ContestPage" element={<ContestPage />} />
        <Route path="/ConfirmationPage" element={<ConfirmationPage />} />
        <Route path="/applications" element={<ApplicationPage />} />
        <Route path="/upload/:studentId" element={<UploadPage />} />
        <Route path="/results/:studentId" element={<ResultsPage />} />
        <Route path="/EylemPlani" element={<EylemPlaniViewer />} />


        
        </Routes>
       
        <Footer/>
    </div>
  );
}

export default App;
